import { useState } from "react";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { Download } from "@solar-icons/react/ssr";

import { downloadFile } from "@/utils";

export default function CsvExportButton(props) {
    const { model, filters } = props;
    const [loading, setLoading] = useState(false);

    const handleExportToCsv = (e) => {
        setLoading(true);
        e.stopPropagation();
        downloadFile(`${model}s/csv-export`, { ...filters }, () =>
            setLoading(false),
        );
    };

    return (
        <Grid
            sx={{ marginTop: 2 }}
            container
            alignItems="center"
            columnSpacing={2}
        >
            <Grid item>
                <Button
                    endIcon={<Download />}
                    onClick={handleExportToCsv}
                    disabled={loading}
                    variant="contained"
                    color="secondary"
                >
                    Export
                </Button>
            </Grid>
            {loading && (
                <Grid item>
                    <CircularProgress size={16} />
                </Grid>
            )}
        </Grid>
    );
}
